import { Component, input } from '@angular/core';
import { IconComponent } from '@libs/stand-alone-components/commons/icon/icon.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-no-data-info',
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.scss'],

  imports: [CommonModule, TranslateModule, IconComponent],
})
export class NoDataComponent {
  title = input<string>('');
  subtitle = input.required<string>();
  noBackground = input<boolean | string>(false);
  icon = input<string>('albums');
}
